import { axios } from '@/services/axios';

const createWholesaler = async (formData) => {
    const response = await axios.post('/wholesaler/', formData);
    return response;
};

export default createWholesaler;
